import React from 'react'
import { useParams } from 'react-router-dom'
import { Formik, Form } from 'formik'

import {
  SuperMidDrySchema,
  initialSuperMidDryValues,
} from '../../utils/validation/superMidDry.js'
import { useSideNav } from '../../contexts/SideNavOpenContext.js'
import { useRecordLock } from '../../contexts/RecordLockContext'
import useSuperMid from '../../hooks/useSuperMid'

import ActionBar from '../shared/ActionBar.js'

import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid'
import TextField from '@mui/material/TextField'
import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import IconButton from '@mui/material/IconButton'

import CheckBoxIcon from '@mui/icons-material/CheckBox'
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank'

import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker'

const SuperMidDry = () => {
  const { id } = useParams()
  const { sideNavOpen } = useSideNav(true)
  const { recordLock, setRecordLock } = useRecordLock()
  const { getSuperMidDraft, patchSuperMidDryDraft } = useSuperMid({ id })

  const handleSave = (values, { setSubmitting }) => {
    patchSuperMidDryDraft.mutate(values)
    setSubmitting(false)
    setRecordLock(true)
  }

  const handleChange = (e, values, setValues) => {
    const name = e.target.name
    const value = e.target.value
    setValues({ ...values, [name]: value })
  }

  const handleChangeCheckbox = (name, values, setValues) => {
    values[name] === `Didn't Startup`
      ? setValues({ ...values, [name]: '' })
      : setValues({ ...values, [name]: `Didn't Startup` })
  }

  const handleDateChange = (name, value, values, setValues) => {
    setValues({ ...values, [name]: value })
  }

  const calTotalPwdPallets = (e, values, setValues) => {
    const name = e.target.name
    const value = e.target.value
    values = { ...values, [name]: value }

    let n1 = parseInt(values.packagingPalletsProduced1) || 0
    let n2 = parseInt(values.packagingPalletsProduced2) || 0
    let n3 = parseInt(values.packagingPalletsProduced3) || 0

    values.packagingTotalPalletsProduced = n1 + n2 + n3

    setValues(values)
  }
  const calTotalMpcPallets = (e, values, setValues) => {
    const name = e.target.name
    const value = e.target.value
    values = { ...values, [name]: value }

    let n1 = parseInt(values.mpcPackagingPalletsProduced1) || 0
    let n2 = parseInt(values.mpcPackagingPalletsProduced2) || 0
    let n3 = parseInt(values.mpcPackagingPalletsProduced3) || 0

    values.mpcPackagingTotalPalletsProduced = n1 + n2 + n3

    setValues(values)
  }
  return (
    <>
      <Formik
        initialValues={{
          ...initialSuperMidDryValues,
          ...getSuperMidDraft?.data,
        }}
        validationSchema={SuperMidDrySchema}
        onSubmit={(values, { setSubmitting }) =>
          handleSave(values, { setSubmitting })
        }
        enableReinitialize
      >
        {({
          isSubmitting,
          handleSubmit,
          values,
          touched,
          errors,
          setValues,
        }) => (
          <>
            <Form id={`SuperMidDry${id}`} onSubmit={handleSubmit}>
              <Grid
                container
                justifyContent='center'
                alignItems='center'
                sx={{
                  pl: sideNavOpen ? '260px' : '60px',
                  pt: '70px',
                  pr: '10px',
                  pb: '100px',
                }}
              >
                <Grid item xs={3}></Grid>
                <Grid item xs={9}>
                  <Typography variant='h1'>
                    Supervisor Mid Shift Passdown Dry Side
                  </Typography>
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Name
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='dryName'
                    disabled={true}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.dryName}
                    error={touched.dryName && !!errors.dryName}
                    helperText={touched.dryName && errors.dryName}
                  />
                </Grid>
                <Grid item xs={3}></Grid>
                <Grid item xs={9}>
                  <span style={{ color: 'red' }}>
                    * Note: Wet and Dry Start Date and Shift must match in order
                    for email to be sent
                  </span>
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Date Shift Started
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <DatePicker
                    name='dryDate'
                    disabled={recordLock}
                    onChange={(value) =>
                      handleDateChange('dryDate', value, values, setValues)
                    }
                    value={values.dryDate}
                    error={touched.dryDate && !!errors.dryDate}
                    helperText={touched.dryDate && errors.dryDate}
                    renderInput={(params) => (
                      <TextField fullWidth size='small' {...params} />
                    )}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Shift
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <Select
                    fullWidth
                    size='small'
                    name='dryShift'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.dryShift}
                    error={touched.dryShift && !!errors.dryShift}
                    helperText={touched.dryShift && errors.dryShift}
                  >
                    <MenuItem value=''>Please Select</MenuItem>
                    <MenuItem value='A Day'>A Day</MenuItem>
                    <MenuItem value='A Night'>A Night</MenuItem>
                    <MenuItem value='B Day'>B Day</MenuItem>
                    <MenuItem value='B Night'>B Night</MenuItem>
                  </Select>
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Message From Sender
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='dryMessage'
                    disabled={recordLock}
                    multiline
                    maxRows={Infinity}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.dryMessage}
                    error={touched.dryMessage && !!errors.dryMessage}
                    helperText={touched.dryMessage && errors.dryMessage}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography variant='h6' sx={{ textAlign: 'right', pr: 1 }}>
                    EVAPORATOR
                  </Typography>
                </Grid>
                <Grid item xs={9}></Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Feed Flow
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='evapFeedFlow'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.evapFeedFlow}
                    error={touched.evapFeedFlow && !!errors.evapFeedFlow}
                    helperText={touched.evapFeedFlow && errors.evapFeedFlow}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Currently Pulling Silo
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='evapCurrentlyPullingSilo'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.evapCurrentlyPullingSilo}
                    error={
                      touched.evapCurrentlyPullingSilo &&
                      !!errors.evapCurrentlyPullingSilo
                    }
                    helperText={
                      touched.evapCurrentlyPullingSilo &&
                      errors.evapCurrentlyPullingSilo
                    }
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Current Turbo Fan %
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='evapCurrentTurboFan'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.evapCurrentTurboFan}
                    error={
                      touched.evapCurrentTurboFan &&
                      !!errors.evapCurrentTurboFan
                    }
                    helperText={
                      touched.evapCurrentTurboFan && errors.evapCurrentTurboFan
                    }
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Turbo Fan % @ Startup
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='evapTurboFanStartup'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.evapTurboFanStartup}
                    error={
                      touched.evapTurboFanStartup &&
                      !!errors.evapTurboFanStartup
                    }
                    helperText={
                      touched.evapTurboFanStartup && errors.evapTurboFanStartup
                    }
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Turbo Fan % @ Shutdown
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='evapTurboFanShutdown'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.evapTurboFanShutdown}
                    error={
                      touched.evapTurboFanShutdown &&
                      !!errors.evapTurboFanShutdown
                    }
                    helperText={
                      touched.evapTurboFanShutdown &&
                      errors.evapTurboFanShutdown
                    }
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Avg size of last 4 moves (eg: 0.3%)
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='evapTurboFanAvgMoveSize'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.evapTurboFanAvgMoveSize}
                    error={
                      touched.evapTurboFanAvgMoveSize &&
                      !!errors.evapTurboFanAvgMoveSize
                    }
                    helperText={
                      touched.evapTurboFanAvgMoveSize &&
                      errors.evapTurboFanAvgMoveSize
                    }
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Avg duration of last 4 moves (eg: 45min)
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='evapTurboFanAvgDurationMoveSize'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.evapTurboFanAvgDurationMoveSize}
                    error={
                      touched.evapTurboFanAvgDurationMoveSize &&
                      !!errors.evapTurboFanAvgDurationMoveSize
                    }
                    helperText={
                      touched.evapTurboFanAvgDurationMoveSize &&
                      errors.evapTurboFanAvgDurationMoveSize
                    }
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Current Product (LH NFDM/MH SMP)
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='evapCurrentProduct'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.evapCurrentProduct}
                    error={
                      touched.evapCurrentProduct && !!errors.evapCurrentProduct
                    }
                    helperText={
                      touched.evapCurrentProduct && errors.evapCurrentProduct
                    }
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Last Flush
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <DateTimePicker
                    name='evapLastFlush'
                    disabled={recordLock}
                    onChange={(value) =>
                      handleDateChange(
                        'evapLastFlush',
                        value,
                        values,
                        setValues
                      )
                    }
                    value={values.evapLastFlush}
                    error={touched.evapLastFlush && !!errors.evapLastFlush}
                    helperText={touched.evapLastFlush && errors.evapLastFlush}
                    renderInput={(params) => (
                      <TextField fullWidth size='small' {...params} />
                    )}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Last On Product
                  </Typography>
                </Grid>
                <Grid
                  item
                  container
                  direction='row'
                  justifyContent='flex-start'
                  alignItems='center'
                  xs={2}
                >
                  {values.evapLastOnProduct !== `Didn't Startup` ? (
                    <IconButton
                      disabled={recordLock}
                      onClick={() =>
                        handleChangeCheckbox(
                          'evapLastOnProduct',
                          values,
                          setValues
                        )
                      }
                    >
                      <CheckBoxOutlineBlankIcon />
                    </IconButton>
                  ) : (
                    <IconButton
                      disabled={recordLock}
                      onClick={() =>
                        handleChangeCheckbox(
                          'evapLastOnProduct',
                          values,
                          setValues
                        )
                      }
                    >
                      <CheckBoxIcon />
                    </IconButton>
                  )}
                  <Typography>Didn't Startup</Typography>
                </Grid>
                <Grid item xs={7}>
                  {values.evapLastOnProduct !== `Didn't Startup` && (
                    <DateTimePicker
                      name='evapLastOnProduct'
                      disabled={recordLock}
                      onChange={(value) =>
                        handleDateChange(
                          'evapLastOnProduct',
                          value,
                          values,
                          setValues
                        )
                      }
                      value={values.evapLastOnProduct}
                      error={
                        touched.evapLastOnProduct && !!errors.evapLastOnProduct
                      }
                      helperText={
                        touched.evapLastOnProduct && errors.evapLastOnProduct
                      }
                      renderInput={(params) => (
                        <TextField fullWidth size='small' {...params} />
                      )}
                    />
                  )}
                </Grid>
                <Grid item xs={3}>
                  <Typography variant='h6' sx={{ textAlign: 'right', pr: 1 }}>
                    DRYER
                  </Typography>
                </Grid>
                <Grid item xs={9}></Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Balance Tank Level
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='dryerBalTnkLvl'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.dryerBalTnkLvl}
                    error={touched.dryerBalTnkLvl && !!errors.dryerBalTnkLvl}
                    helperText={touched.dryerBalTnkLvl && errors.dryerBalTnkLvl}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    HPP Pressure
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='dryerHppPressure'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.dryerHppPressure}
                    error={
                      touched.dryerHppPressure && !!errors.dryerHppPressure
                    }
                    helperText={
                      touched.dryerHppPressure && errors.dryerHppPressure
                    }
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    HPP Motor
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='dryerHppMotor'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.dryerHppMotor}
                    error={touched.dryerHppMotor && !!errors.dryerHppMotor}
                    helperText={touched.dryerHppMotor && errors.dryerHppMotor}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    N Bag House Differential Pressure
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='dryerNBagDiffPressure'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.dryerNBagDiffPressure}
                    error={
                      touched.dryerNBagDiffPressure &&
                      !!errors.dryerNBagDiffPressure
                    }
                    helperText={
                      touched.dryerNBagDiffPressure &&
                      errors.dryerNBagDiffPressure
                    }
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    S Bag House Differential Pressure
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='dryerSBagDiffPressure'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.dryerSBagDiffPressure}
                    error={
                      touched.dryerSBagDiffPressure &&
                      !!errors.dryerSBagDiffPressure
                    }
                    helperText={
                      touched.dryerSBagDiffPressure &&
                      errors.dryerSBagDiffPressure
                    }
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Dryer Nozzle Issues? (If Y, explain)
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='dryerNozzleIssues'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.dryerNozzleIssues}
                    error={
                      touched.dryerNozzleIssues && !!errors.dryerNozzleIssues
                    }
                    helperText={
                      touched.dryerNozzleIssues && errors.dryerNozzleIssues
                    }
                  />
                </Grid>

                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Avg Fat
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='dryerAvgFat'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.dryerAvgFat}
                    error={touched.dryerAvgFat && !!errors.dryerAvgFat}
                    helperText={touched.dryerAvgFat && errors.dryerAvgFat}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Avg Moisture
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='dryerAvgMoist'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.dryerAvgMoist}
                    error={touched.dryerAvgMoist && !!errors.dryerAvgMoist}
                    helperText={touched.dryerAvgMoist && errors.dryerAvgMoist}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Avg Protein
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='dryerAvgProt'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.dryerAvgProt}
                    error={touched.dryerAvgProt && !!errors.dryerAvgProt}
                    helperText={touched.dryerAvgProt && errors.dryerAvgProt}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    WPN Range
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='dryerWpnRange'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.dryerWpnRange}
                    error={touched.dryerWpnRange && !!errors.dryerWpnRange}
                    helperText={touched.dryerWpnRange && errors.dryerWpnRange}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Avg Scorch Pad (A,B,C,D)
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <Select
                    fullWidth
                    size='small'
                    name='dryerAvgScorch'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.dryerAvgScorch}
                    error={touched.dryerAvgScorch && !!errors.dryerAvgScorch}
                    helperText={touched.dryerAvgScorch && errors.dryerAvgScorch}
                  >
                    <MenuItem value=''>Please Select</MenuItem>
                    <MenuItem value='N/A'>N/A</MenuItem>
                    <MenuItem value='A'>A</MenuItem>
                    <MenuItem value='B'>B</MenuItem>
                    <MenuItem value='C'>C</MenuItem>
                    <MenuItem value='D'>D</MenuItem>
                  </Select>
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Fluid Bed Outlet Temp
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='dryerFluidBedOutletTemp'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.dryerFluidBedOutletTemp}
                    error={
                      touched.dryerFluidBedOutletTemp &&
                      !!errors.dryerFluidBedOutletTemp
                    }
                    helperText={
                      touched.dryerFluidBedOutletTemp &&
                      errors.dryerFluidBedOutletTemp
                    }
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Sifting Pwd Needing Fixed? (If Y, area?)
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='dryerSiftingNeedingFixed'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.dryerSiftingNeedingFixed}
                    error={
                      touched.dryerSiftingNeedingFixed &&
                      !!errors.dryerSiftingNeedingFixed
                    }
                    helperText={
                      touched.dryerSiftingNeedingFixed &&
                      errors.dryerSiftingNeedingFixed
                    }
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography variant='h6' sx={{ textAlign: 'right', pr: 1 }}>
                    POWDER SILOS
                  </Typography>
                </Grid>
                <Grid item xs={3}>
                  <Typography variant='h6' sx={{ textAlign: 'center', pr: 1 }}>
                    Volume (%)
                  </Typography>
                </Grid>
                <Grid item xs={3}>
                  <Typography variant='h6' sx={{ textAlign: 'center', pr: 1 }}>
                    Product
                  </Typography>
                </Grid>
                <Grid item xs={3}>
                  <Typography variant='h6' sx={{ textAlign: 'center', pr: 1 }}>
                    Status
                  </Typography>
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Silo 1
                  </Typography>
                </Grid>

                <Grid item xs={3}>
                  <TextField
                    fullWidth
                    size='small'
                    name='pwdSilo1Volume'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.pwdSilo1Volume}
                    error={touched.pwdSilo1Volume && !!errors.pwdSilo1Volume}
                    helperText={touched.pwdSilo1Volume && errors.pwdSilo1Volume}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Select
                    fullWidth
                    size='small'
                    name='pwdSilo1Product'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.pwdSilo1Product}
                    error={touched.pwdSilo1Product && !!errors.pwdSilo1Product}
                    helperText={
                      touched.pwdSilo1Product && errors.pwdSilo1Product
                    }
                  >
                    <MenuItem value=''>Please Select</MenuItem>
                    <MenuItem value='Low Heat'>Low Heat</MenuItem>
                    <MenuItem value='Med Heat'>Med Heat</MenuItem>
                    <MenuItem value='High Heat'>High Heat</MenuItem>
                    <MenuItem value='Buttermilk'>Buttermilk</MenuItem>
                  </Select>
                </Grid>
                <Grid item xs={3}>
                  <Select
                    fullWidth
                    size='small'
                    name='pwdSilo1Status'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.pwdSilo1Status}
                    error={touched.pwdSilo1Status && !!errors.pwdSilo1Status}
                    helperText={touched.pwdSilo1Status && errors.pwdSilo1Status}
                  >
                    <MenuItem value=''>Please Select</MenuItem>
                    <MenuItem value='Filling'>Filling</MenuItem>
                    <MenuItem value='Pulling'>Pulling</MenuItem>
                    <MenuItem value='Filling & Pulling'>
                      Filling & Pulling
                    </MenuItem>
                    <MenuItem value='Tempering'>Tempering</MenuItem>
                    <MenuItem value='Waiting To Process'>
                      Waiting To Process
                    </MenuItem>
                    <MenuItem value='Empty'>Empty</MenuItem>
                    <MenuItem value='N/A'>N/A</MenuItem>
                  </Select>
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Silo 2
                  </Typography>
                </Grid>
                <Grid item xs={3}>
                  <TextField
                    fullWidth
                    size='small'
                    name='pwdSilo2Volume'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.pwdSilo2Volume}
                    error={touched.pwdSilo2Volume && !!errors.pwdSilo2Volume}
                    helperText={touched.pwdSilo2Volume && errors.pwdSilo2Volume}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Select
                    fullWidth
                    size='small'
                    name='pwdSilo2Product'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.pwdSilo2Product}
                    error={touched.pwdSilo2Product && !!errors.pwdSilo2Product}
                    helperText={
                      touched.pwdSilo2Product && errors.pwdSilo2Product
                    }
                  >
                    <MenuItem value=''>Please Select</MenuItem>
                    <MenuItem value='Low Heat'>Low Heat</MenuItem>
                    <MenuItem value='Med Heat'>Med Heat</MenuItem>
                    <MenuItem value='High Heat'>High Heat</MenuItem>
                    <MenuItem value='Buttermilk'>Buttermilk</MenuItem>
                  </Select>
                </Grid>
                <Grid item xs={3}>
                  <Select
                    fullWidth
                    size='small'
                    name='pwdSilo2Status'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.pwdSilo2Status}
                    error={touched.pwdSilo2Status && !!errors.pwdSilo2Status}
                    helperText={touched.pwdSilo2Status && errors.pwdSilo2Status}
                  >
                    <MenuItem value=''>Please Select</MenuItem>
                    <MenuItem value='Filling'>Filling</MenuItem>
                    <MenuItem value='Pulling'>Pulling</MenuItem>
                    <MenuItem value='Filling & Pulling'>
                      Filling & Pulling
                    </MenuItem>
                    <MenuItem value='Tempering'>Tempering</MenuItem>
                    <MenuItem value='Waiting To Process'>
                      Waiting To Process
                    </MenuItem>
                    <MenuItem value='Empty'>Empty</MenuItem>
                    <MenuItem value='N/A'>N/A</MenuItem>
                  </Select>
                </Grid>
                <Grid item xs={3}>
                  <Typography variant='h6' sx={{ textAlign: 'right', pr: 1 }}>
                    PACKAGING
                  </Typography>
                </Grid>
                <Grid item xs={9}></Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Current Product
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='packagingCurrentProduct'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.packagingCurrentProduct}
                    error={
                      touched.packagingCurrentProduct &&
                      !!errors.packagingCurrentProduct
                    }
                    helperText={
                      touched.packagingCurrentProduct &&
                      errors.packagingCurrentProduct
                    }
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    # Pallets/Totes Produced
                  </Typography>
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    fullWidth
                    size='small'
                    name='packagingPalletsProduced1'
                    disabled={recordLock}
                    onChange={(e) => calTotalPwdPallets(e, values, setValues)}
                    value={values.packagingPalletsProduced1}
                    error={
                      touched.packagingPalletsProduced1 &&
                      !!errors.packagingPalletsProduced1
                    }
                    helperText={
                      touched.packagingPalletsProduced1 &&
                      errors.packagingPalletsProduced1
                    }
                  />
                </Grid>
                <Grid item xs={1}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Product
                  </Typography>
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    fullWidth
                    size='small'
                    name='packagingProductProduced1'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.packagingProductProduced1}
                    error={
                      touched.packagingProductProduced1 &&
                      !!errors.packagingProductProduced1
                    }
                    helperText={
                      touched.packagingProductProduced1 &&
                      errors.packagingProductProduced1
                    }
                  />
                </Grid>
                <Grid item xs={3}></Grid>
                <Grid item xs={4}>
                  <TextField
                    fullWidth
                    size='small'
                    name='packagingPalletsProduced2'
                    disabled={recordLock}
                    onChange={(e) => calTotalPwdPallets(e, values, setValues)}
                    value={values.packagingPalletsProduced2}
                    error={
                      touched.packagingPalletsProduced2 &&
                      !!errors.packagingPalletsProduced2
                    }
                    helperText={
                      touched.packagingPalletsProduced2 &&
                      errors.packagingPalletsProduced2
                    }
                  />
                </Grid>
                <Grid item xs={1}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Product
                  </Typography>
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    fullWidth
                    size='small'
                    name='packagingProductProduced2'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.packagingProductProduced2}
                    error={
                      touched.packagingProductProduced2 &&
                      !!errors.packagingProductProduced2
                    }
                    helperText={
                      touched.packagingProductProduced2 &&
                      errors.packagingProductProduced2
                    }
                  />
                </Grid>
                <Grid item xs={3}></Grid>
                <Grid item xs={4}>
                  <TextField
                    fullWidth
                    size='small'
                    name='packagingPalletsProduced3'
                    disabled={recordLock}
                    onChange={(e) => calTotalPwdPallets(e, values, setValues)}
                    value={values.packagingPalletsProduced3}
                    error={
                      touched.packagingPalletsProduced3 &&
                      !!errors.packagingPalletsProduced3
                    }
                    helperText={
                      touched.packagingPalletsProduced3 &&
                      errors.packagingPalletsProduced3
                    }
                  />
                </Grid>
                <Grid item xs={1}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Product
                  </Typography>
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    fullWidth
                    size='small'
                    name='packagingProductProduced3'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.packagingProductProduced3}
                    error={
                      touched.packagingProductProduced3 &&
                      !!errors.packagingProductProduced3
                    }
                    helperText={
                      touched.packagingProductProduced3 &&
                      errors.packagingProductProduced3
                    }
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Total Pallets/Totes Produced
                  </Typography>
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    fullWidth
                    size='small'
                    name='packagingTotalPalletsProduced'
                    disabled={true}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.packagingTotalPalletsProduced}
                    error={
                      touched.packagingTotalPalletsProduced &&
                      !!errors.packagingTotalPalletsProduced
                    }
                    helperText={
                      touched.packagingTotalPalletsProduced &&
                      errors.packagingTotalPalletsProduced
                    }
                  />
                </Grid>
                <Grid item xs={5}></Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    AF - Nuisance Dust Lbs
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='packagingAfNuisanceLbs'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.packagingAfNuisanceLbs}
                    error={
                      touched.packagingAfNuisanceLbs &&
                      !!errors.packagingAfNuisanceLbs
                    }
                    helperText={
                      touched.packagingAfNuisanceLbs &&
                      errors.packagingAfNuisanceLbs
                    }
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    AF - Vacuum Lbs
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='packagingAfVacuumLbs'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.packagingAfVacuumLbs}
                    error={
                      touched.packagingAfVacuumLbs &&
                      !!errors.packagingAfVacuumLbs
                    }
                    helperText={
                      touched.packagingAfVacuumLbs &&
                      errors.packagingAfVacuumLbs
                    }
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    AF - Scrapings Lbs
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='packagingAfScrapingsLbs'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.packagingAfScrapingsLbs}
                    error={
                      touched.packagingAfScrapingsLbs &&
                      !!errors.packagingAfScrapingsLbs
                    }
                    helperText={
                      touched.packagingAfScrapingsLbs &&
                      errors.packagingAfScrapingsLbs
                    }
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    AF - Tailings Lbs
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='packagingAfTailingsLbs'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.packagingAfTailingsLbs}
                    error={
                      touched.packagingAfTailingsLbs &&
                      !!errors.packagingAfTailingsLbs
                    }
                    helperText={
                      touched.packagingAfTailingsLbs &&
                      errors.packagingAfTailingsLbs
                    }
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    AF - Operator Tote Lbs
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='packagingAfOperatorToteLbs'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.packagingAfOperatorToteLbs}
                    error={
                      touched.packagingAfOperatorToteLbs &&
                      !!errors.packagingAfOperatorToteLbs
                    }
                    helperText={
                      touched.packagingAfOperatorToteLbs &&
                      errors.packagingAfOperatorToteLbs
                    }
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Recon Lbs
                  </Typography>
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    fullWidth
                    size='small'
                    name='packagingReconLbs'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.packagingReconLbs}
                    error={
                      touched.packagingReconLbs && !!errors.packagingReconLbs
                    }
                    helperText={
                      touched.packagingReconLbs && errors.packagingReconLbs
                    }
                  />
                </Grid>
                <Grid item xs={1}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    # of Totes?
                  </Typography>
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    fullWidth
                    size='small'
                    name='packagingReconTotes'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.packagingReconTotes}
                    error={
                      touched.packagingReconTotes &&
                      !!errors.packagingReconTotes
                    }
                    helperText={
                      touched.packagingReconTotes && errors.packagingReconTotes
                    }
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Accupoint Swabs Completed (Y/N)
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='packagingAccupointSwabsCompleted'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.packagingAccupointSwabsCompleted}
                    error={
                      touched.packagingAccupointSwabsCompleted &&
                      !!errors.packagingAccupointSwabsCompleted
                    }
                    helperText={
                      touched.packagingAccupointSwabsCompleted &&
                      errors.packagingAccupointSwabsCompleted
                    }
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    # Pallets Reworked
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='packagingPalletsReworked'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.packagingPalletsReworked}
                    error={
                      touched.packagingPalletsReworked &&
                      !!errors.packagingPalletsReworked
                    }
                    helperText={
                      touched.packagingPalletsReworked &&
                      errors.packagingPalletsReworked
                    }
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    % Seal Checks In Spec
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='packagingSealChecksInSpec'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.packagingSealChecksInSpec}
                    error={
                      touched.packagingSealChecksInSpec &&
                      !!errors.packagingSealChecksInSpec
                    }
                    helperText={
                      touched.packagingSealChecksInSpec &&
                      errors.packagingSealChecksInSpec
                    }
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Sifting Pwd Needing Fixed (If Y, area?)
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='packagingSiftingPwdNeedingFixed'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.packagingSiftingPwdNeedingFixed}
                    error={
                      touched.packagingSiftingPwdNeedingFixed &&
                      !!errors.packagingSiftingPwdNeedingFixed
                    }
                    helperText={
                      touched.packagingSiftingPwdNeedingFixed &&
                      errors.packagingSiftingPwdNeedingFixed
                    }
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    % Weight Checks in Spec
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='packagingWeightChecksInSpec'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.packagingWeightChecksInSpec}
                    error={
                      touched.packagingWeightChecksInSpec &&
                      !!errors.packagingWeightChecksInSpec
                    }
                    helperText={
                      touched.packagingWeightChecksInSpec &&
                      errors.packagingWeightChecksInSpec
                    }
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Condition of Deck 2
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <Select
                    fullWidth
                    size='small'
                    name='packagingConditionDeck2'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.packagingConditionDeck2}
                    error={
                      touched.packagingConditionDeck2 &&
                      !!errors.packagingConditionDeck2
                    }
                    helperText={
                      touched.packagingConditionDeck2 &&
                      errors.packagingConditionDeck2
                    }
                  >
                    <MenuItem value=''>Please Select</MenuItem>
                    <MenuItem value='1-Very Poor (Powder on walls, floor, and machinery, needs lots of work!)'>
                      1-Very Poor (Powder on walls, floor, and machinery, needs
                      lots of work!)
                    </MenuItem>
                    <MenuItem value='2-Poor (Some powder on walls, floor, or machinery, needs some work)'>
                      2-Poor (Some powder on walls, floor, or machinery, needs
                      some work)
                    </MenuItem>
                    <MenuItem value='3-Decent (Most of the powder is cleaned up, still could use some attention)'>
                      3-Decent (Most of the powder is cleaned up, still could
                      use some attention)
                    </MenuItem>
                    <MenuItem value='4-Good (Most of the powder is cleaned up with little time could be spotless'>
                      4-Good (Most of the powder is cleaned up with little time
                      could be spotless)
                    </MenuItem>
                    <MenuItem value='5-Excellent (No powder in sight, everything in proper place'>
                      5-Excellent (No powder in sight, everything in proper
                      place)
                    </MenuItem>
                  </Select>
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Condition of Deck 3
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <Select
                    fullWidth
                    size='small'
                    name='packagingConditionDeck3'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.packagingConditionDeck3}
                    error={
                      touched.packagingConditionDeck3 &&
                      !!errors.packagingConditionDeck3
                    }
                    helperText={
                      touched.packagingConditionDeck3 &&
                      errors.packagingConditionDeck3
                    }
                  >
                    <MenuItem value=''>Please Select</MenuItem>
                    <MenuItem value='1-Very Poor (Powder on walls, floor, and machinery, needs lots of work!)'>
                      1-Very Poor (Powder on walls, floor, and machinery, needs
                      lots of work!)
                    </MenuItem>
                    <MenuItem value='2-Poor (Some powder on walls, floor, or machinery, needs some work)'>
                      2-Poor (Some powder on walls, floor, or machinery, needs
                      some work)
                    </MenuItem>
                    <MenuItem value='3-Decent (Most of the powder is cleaned up, still could use some attention)'>
                      3-Decent (Most of the powder is cleaned up, still could
                      use some attention)
                    </MenuItem>
                    <MenuItem value='4-Good (Most of the powder is cleaned up with little time could be spotless'>
                      4-Good (Most of the powder is cleaned up with little time
                      could be spotless)
                    </MenuItem>
                    <MenuItem value='5-Excellent (No powder in sight, everything in proper place'>
                      5-Excellent (No powder in sight, everything in proper
                      place)
                    </MenuItem>
                  </Select>
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Deep Clean Area
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <Select
                    fullWidth
                    size='small'
                    name='packagingDeepCleanArea'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.packagingDeepCleanArea}
                    error={
                      touched.packagingDeepCleanArea &&
                      !!errors.packagingDeepCleanArea
                    }
                    helperText={
                      touched.packagingDeepCleanArea &&
                      errors.packagingDeepCleanArea
                    }
                  >
                    <MenuItem value=''>Please Select</MenuItem>
                    <MenuItem value='1-Very Poor (Powder on walls, floor, and machinery, needs lots of work!)'>
                      1-Very Poor (Powder on walls, floor, and machinery, needs
                      lots of work!)
                    </MenuItem>
                    <MenuItem value='2-Poor (Some powder on walls, floor, or machinery, needs some work)'>
                      2-Poor (Some powder on walls, floor, or machinery, needs
                      some work)
                    </MenuItem>
                    <MenuItem value='3-Decent (Most of the powder is cleaned up, still could use some attention)'>
                      3-Decent (Most of the powder is cleaned up, still could
                      use some attention)
                    </MenuItem>
                    <MenuItem value='4-Good (Most of the powder is cleaned up with little time could be spotless'>
                      4-Good (Most of the powder is cleaned up with little time
                      could be spotless)
                    </MenuItem>
                    <MenuItem value='5-Excellent (No powder in sight, everything in proper place'>
                      5-Excellent (No powder in sight, everything in proper
                      place)
                    </MenuItem>
                  </Select>
                </Grid>

                <Grid item xs={3}>
                  <Typography variant='h6' sx={{ textAlign: 'right', pr: 1 }}>
                    MPC DRYER
                  </Typography>
                </Grid>
                <Grid item xs={9}></Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Balance Tank Level
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='mpcDryerBalTnkLvl'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.mpcDryerBalTnkLvl}
                    error={
                      touched.mpcDryerBalTnkLvl && !!errors.mpcDryerBalTnkLvl
                    }
                    helperText={
                      touched.mpcDryerBalTnkLvl && errors.mpcDryerBalTnkLvl
                    }
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    HPP Pressure
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='mpcDryerHppPressure'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.mpcDryerHppPressure}
                    error={
                      touched.mpcDryerHppPressure &&
                      !!errors.mpcDryerHppPressure
                    }
                    helperText={
                      touched.mpcDryerHppPressure && errors.mpcDryerHppPressure
                    }
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    HPP Motor
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='mpcDryerHppMotor'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.mpcDryerHppMotor}
                    error={
                      touched.mpcDryerHppMotor && !!errors.mpcDryerHppMotor
                    }
                    helperText={
                      touched.mpcDryerHppMotor && errors.mpcDryerHppMotor
                    }
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    N Bag House Differential Pressure
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='mpcDryerNBagDiffPressure'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.mpcDryerNBagDiffPressure}
                    error={
                      touched.mpcDryerNBagDiffPressure &&
                      !!errors.mpcDryerNBagDiffPressure
                    }
                    helperText={
                      touched.mpcDryerNBagDiffPressure &&
                      errors.mpcDryerNBagDiffPressure
                    }
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    S Bag House Differential Pressure
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='mpcDryerSBagDiffPressure'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.mpcDryerSBagDiffPressure}
                    error={
                      touched.mpcDryerSBagDiffPressure &&
                      !!errors.mpcDryerSBagDiffPressure
                    }
                    helperText={
                      touched.mpcDryerSBagDiffPressure &&
                      errors.mpcDryerSBagDiffPressure
                    }
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Dryer Nozzle Issues? (If Y, explain)
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='mpcDryerNozzleIssues'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.mpcDryerNozzleIssues}
                    error={
                      touched.mpcDryerNozzleIssues &&
                      !!errors.mpcDryerNozzleIssues
                    }
                    helperText={
                      touched.mpcDryerNozzleIssues &&
                      errors.mpcDryerNozzleIssues
                    }
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Avg Moisture
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='mpcDryerAvgMoist'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.mpcDryerAvgMoist}
                    error={
                      touched.mpcDryerAvgMoist && !!errors.mpcDryerAvgMoist
                    }
                    helperText={
                      touched.mpcDryerAvgMoist && errors.mpcDryerAvgMoist
                    }
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Avg Protein
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='mpcDryerAvgProt'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.mpcDryerAvgProt}
                    error={touched.mpcDryerAvgProt && !!errors.mpcDryerAvgProt}
                    helperText={
                      touched.mpcDryerAvgProt && errors.mpcDryerAvgProt
                    }
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    WPN Range
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='mpcDryerWpnRange'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.mpcDryerWpnRange}
                    error={
                      touched.mpcDryerWpnRange && !!errors.mpcDryerWpnRange
                    }
                    helperText={
                      touched.mpcDryerWpnRange && errors.mpcDryerWpnRange
                    }
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Avg Scorch Pad (A,B,C,D)
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <Select
                    fullWidth
                    size='small'
                    name='mpcDryerAvgScorch'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.mpcDryerAvgScorch}
                    error={
                      touched.mpcDryerAvgScorch && !!errors.mpcDryerAvgScorch
                    }
                    helperText={
                      touched.mpcDryerAvgScorch && errors.mpcDryerAvgScorch
                    }
                  >
                    <MenuItem value=''>Please Select</MenuItem>
                    <MenuItem value='N/A'>N/A</MenuItem>
                    <MenuItem value='A'>A</MenuItem>
                    <MenuItem value='B'>B</MenuItem>
                    <MenuItem value='C'>C</MenuItem>
                    <MenuItem value='D'>D</MenuItem>
                  </Select>
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Fluid Bed Outlet Temp
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='mpcDryerFluidBedOutletTemp'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.mpcDryerFluidBedOutletTemp}
                    error={
                      touched.mpcDryerFluidBedOutletTemp &&
                      !!errors.mpcDryerFluidBedOutletTemp
                    }
                    helperText={
                      touched.mpcDryerFluidBedOutletTemp &&
                      errors.mpcDryerFluidBedOutletTemp
                    }
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Sifting Pwd Needing Fixed? (If Y, area?)
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='mpcDryerSiftingNeedingFixed'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.mpcDryerSiftingNeedingFixed}
                    error={
                      touched.mpcDryerSiftingNeedingFixed &&
                      !!errors.mpcDryerSiftingNeedingFixed
                    }
                    helperText={
                      touched.mpcDryerSiftingNeedingFixed &&
                      errors.mpcDryerSiftingNeedingFixed
                    }
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography variant='h6' sx={{ textAlign: 'right', pr: 1 }}>
                    MPC POWDER SILOS
                  </Typography>
                </Grid>
                <Grid item xs={3}>
                  <Typography variant='h6' sx={{ textAlign: 'center', pr: 1 }}>
                    Volume (lbs)
                  </Typography>
                </Grid>
                <Grid item xs={3}>
                  <Typography variant='h6' sx={{ textAlign: 'center', pr: 1 }}>
                    Product
                  </Typography>
                </Grid>
                <Grid item xs={3}>
                  <Typography variant='h6' sx={{ textAlign: 'center', pr: 1 }}>
                    Status
                  </Typography>
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Silo 1
                  </Typography>
                </Grid>
                <Grid item xs={3}>
                  <TextField
                    fullWidth
                    size='small'
                    name='mpcSilo1Volume'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.mpcSilo1Volume}
                    error={touched.mpcSilo1Volume && !!errors.mpcSilo1Volume}
                    helperText={touched.mpcSilo1Volume && errors.mpcSilo1Volume}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Select
                    fullWidth
                    size='small'
                    name='mpcSilo1Product'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.mpcSilo1Product}
                    error={touched.mpcSilo1Product && !!errors.mpcSilo1Product}
                    helperText={
                      touched.mpcSilo1Product && errors.mpcSilo1Product
                    }
                  >
                    <MenuItem value=''>Please Select</MenuItem>
                    <MenuItem value='MPC70'>MPC70</MenuItem>
                    <MenuItem value='MPC80'>MPC80</MenuItem>
                    <MenuItem value='MPC85'>MPC85</MenuItem>
                  </Select>
                </Grid>
                <Grid item xs={3}>
                  <Select
                    fullWidth
                    size='small'
                    name='mpcSilo1Status'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.mpcSilo1Status}
                    error={touched.mpcSilo1Status && !!errors.mpcSilo1Status}
                    helperText={touched.mpcSilo1Status && errors.mpcSilo1Status}
                  >
                    <MenuItem value=''>Please Select</MenuItem>
                    <MenuItem value='Filling'>Filling</MenuItem>
                    <MenuItem value='Pulling'>Pulling</MenuItem>
                    <MenuItem value='Filling & Pulling'>
                      Filling & Pulling
                    </MenuItem>
                    <MenuItem value='Tempering'>Tempering</MenuItem>
                    <MenuItem value='Waiting To Process'>
                      Waiting To Process
                    </MenuItem>
                    <MenuItem value='Empty'>Empty</MenuItem>
                    <MenuItem value='N/A'>N/A</MenuItem>
                  </Select>
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Silo 2
                  </Typography>
                </Grid>
                <Grid item xs={3}>
                  <TextField
                    fullWidth
                    size='small'
                    name='mpcSilo2Volume'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.mpcSilo2Volume}
                    error={touched.mpcSilo2Volume && !!errors.mpcSilo2Volume}
                    helperText={touched.mpcSilo2Volume && errors.mpcSilo2Volume}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Select
                    fullWidth
                    size='small'
                    name='mpcSilo2Product'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.mpcSilo2Product}
                    error={touched.mpcSilo2Product && !!errors.mpcSilo2Product}
                    helperText={
                      touched.mpcSilo2Product && errors.mpcSilo2Product
                    }
                  >
                    <MenuItem value=''>Please Select</MenuItem>
                    <MenuItem value='MPC70'>MPC70</MenuItem>
                    <MenuItem value='MPC80'>MPC80</MenuItem>
                    <MenuItem value='MPC85'>MPC85</MenuItem>
                  </Select>
                </Grid>
                <Grid item xs={3}>
                  <Select
                    fullWidth
                    size='small'
                    name='mpcSilo2Status'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.mpcSilo2Status}
                    error={touched.mpcSilo2Status && !!errors.mpcSilo2Status}
                    helperText={touched.mpcSilo2Status && errors.mpcSilo2Status}
                  >
                    <MenuItem value=''>Please Select</MenuItem>
                    <MenuItem value='Filling'>Filling</MenuItem>
                    <MenuItem value='Pulling'>Pulling</MenuItem>
                    <MenuItem value='Filling & Pulling'>
                      Filling & Pulling
                    </MenuItem>
                    <MenuItem value='Tempering'>Tempering</MenuItem>
                    <MenuItem value='Waiting To Process'>
                      Waiting To Process
                    </MenuItem>
                    <MenuItem value='Empty'>Empty</MenuItem>
                    <MenuItem value='N/A'>N/A</MenuItem>
                  </Select>
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Silo 3
                  </Typography>
                </Grid>
                <Grid item xs={3}>
                  <TextField
                    fullWidth
                    size='small'
                    name='mpcSilo3Volume'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.mpcSilo3Volume}
                    error={touched.mpcSilo3Volume && !!errors.mpcSilo3Volume}
                    helperText={touched.mpcSilo3Volume && errors.mpcSilo3Volume}
                  />
                </Grid>
                <Grid item xs={3}>
                  <Select
                    fullWidth
                    size='small'
                    name='mpcSilo3Product'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.mpcSilo3Product}
                    error={touched.mpcSilo3Product && !!errors.mpcSilo3Product}
                    helperText={
                      touched.mpcSilo3Product && errors.mpcSilo3Product
                    }
                  >
                    <MenuItem value=''>Please Select</MenuItem>
                    <MenuItem value='MPC70'>MPC70</MenuItem>
                    <MenuItem value='MPC80'>MPC80</MenuItem>
                    <MenuItem value='MPC85'>MPC85</MenuItem>
                  </Select>
                </Grid>
                <Grid item xs={3}>
                  <Select
                    fullWidth
                    size='small'
                    name='mpcSilo3Status'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.mpcSilo3Status}
                    error={touched.mpcSilo3Status && !!errors.mpcSilo3Status}
                    helperText={touched.mpcSilo3Status && errors.mpcSilo3Status}
                  >
                    <MenuItem value=''>Please Select</MenuItem>
                    <MenuItem value='Filling'>Filling</MenuItem>
                    <MenuItem value='Pulling'>Pulling</MenuItem>
                    <MenuItem value='Filling & Pulling'>
                      Filling & Pulling
                    </MenuItem>
                    <MenuItem value='Tempering'>Tempering</MenuItem>
                    <MenuItem value='Waiting To Process'>
                      Waiting To Process
                    </MenuItem>
                    <MenuItem value='Empty'>Empty</MenuItem>
                    <MenuItem value='N/A'>N/A</MenuItem>
                  </Select>
                </Grid>
                <Grid item xs={3}>
                  <Typography variant='h6' sx={{ textAlign: 'right', pr: 1 }}>
                    MPC PACKAGING
                  </Typography>
                </Grid>
                <Grid item xs={9}></Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Current Product
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='mpcPackagingCurrentProduct'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.mpcPackagingCurrentProduct}
                    error={
                      touched.mpcPackagingCurrentProduct &&
                      !!errors.mpcPackagingCurrentProduct
                    }
                    helperText={
                      touched.mpcPackagingCurrentProduct &&
                      errors.mpcPackagingCurrentProduct
                    }
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    # Pallets/Totes Produced
                  </Typography>
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    fullWidth
                    size='small'
                    name='mpcPackagingPalletsProduced1'
                    disabled={recordLock}
                    onChange={(e) => calTotalMpcPallets(e, values, setValues)}
                    value={values.mpcPackagingPalletsProduced1}
                    error={
                      touched.mpcPackagingPalletsProduced1 &&
                      !!errors.mpcPackagingPalletsProduced1
                    }
                    helperText={
                      touched.mpcPackagingPalletsProduced1 &&
                      errors.mpcPackagingPalletsProduced1
                    }
                  />
                </Grid>
                <Grid item xs={1}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Product
                  </Typography>
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    fullWidth
                    size='small'
                    name='mpcPackagingProductProduced1'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.mpcPackagingProductProduced1}
                    error={
                      touched.mpcPackagingProductProduced1 &&
                      !!errors.mpcPackagingProductProduced1
                    }
                    helperText={
                      touched.mpcPackagingProductProduced1 &&
                      errors.mpcPackagingProductProduced1
                    }
                  />
                </Grid>
                <Grid item xs={3}></Grid>
                <Grid item xs={4}>
                  <TextField
                    fullWidth
                    size='small'
                    name='mpcPackagingPalletsProduced2'
                    disabled={recordLock}
                    onChange={(e) => calTotalMpcPallets(e, values, setValues)}
                    value={values.mpcPackagingPalletsProduced2}
                    error={
                      touched.mpcPackagingPalletsProduced2 &&
                      !!errors.mpcPackagingPalletsProduced2
                    }
                    helperText={
                      touched.mpcPackagingPalletsProduced2 &&
                      errors.mpcPackagingPalletsProduced2
                    }
                  />
                </Grid>
                <Grid item xs={1}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Product
                  </Typography>
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    fullWidth
                    size='small'
                    name='mpcPackagingProductProduced2'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.mpcPackagingProductProduced2}
                    error={
                      touched.mpcPackagingProductProduced2 &&
                      !!errors.mpcPackagingProductProduced2
                    }
                    helperText={
                      touched.mpcPackagingProductProduced2 &&
                      errors.mpcPackagingProductProduced2
                    }
                  />
                </Grid>
                <Grid item xs={3}></Grid>
                <Grid item xs={4}>
                  <TextField
                    fullWidth
                    size='small'
                    name='mpcPackagingPalletsProduced3'
                    disabled={recordLock}
                    onChange={(e) => calTotalMpcPallets(e, values, setValues)}
                    value={values.mpcPackagingPalletsProduced3}
                    error={
                      touched.mpcPackagingPalletsProduced3 &&
                      !!errors.mpcPackagingPalletsProduced3
                    }
                    helperText={
                      touched.mpcPackagingPalletsProduced3 &&
                      errors.mpcPackagingPalletsProduced3
                    }
                  />
                </Grid>
                <Grid item xs={1}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Product
                  </Typography>
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    fullWidth
                    size='small'
                    name='mpcPackagingProductProduced3'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.mpcPackagingProductProduced3}
                    error={
                      touched.mpcPackagingProductProduced3 &&
                      !!errors.mpcPackagingProductProduced3
                    }
                    helperText={
                      touched.mpcPackagingProductProduced3 &&
                      errors.mpcPackagingProductProduced3
                    }
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Total Pallets/Totes Produced
                  </Typography>
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    fullWidth
                    size='small'
                    name='mpcPackagingTotalPalletsProduced'
                    disabled={true}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.mpcPackagingTotalPalletsProduced}
                    error={
                      touched.mpcPackagingTotalPalletsProduced &&
                      !!errors.mpcPackagingTotalPalletsProduced
                    }
                    helperText={
                      touched.mpcPackagingTotalPalletsProduced &&
                      errors.mpcPackagingTotalPalletsProduced
                    }
                  />
                </Grid>
                <Grid item xs={5}></Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    AF Lbs
                  </Typography>
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    fullWidth
                    size='small'
                    name='mpcPackagingAfLbs'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.mpcPackagingAfLbs}
                    error={
                      touched.mpcPackagingAfLbs && !!errors.mpcPackagingAfLbs
                    }
                    helperText={
                      touched.mpcPackagingAfLbs && errors.mpcPackagingAfLbs
                    }
                  />
                </Grid>
                <Grid item xs={1}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    # of Totes?
                  </Typography>
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    fullWidth
                    size='small'
                    name='mpcPackagingAfTotes'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.mpcPackagingAfTotes}
                    error={
                      touched.mpcPackagingAfTotes &&
                      !!errors.mpcPackagingAfTotes
                    }
                    helperText={
                      touched.mpcPackagingAfTotes && errors.mpcPackagingAfTotes
                    }
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    AF - Floor Sweepings Lbs
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='mpcPackagingAfFlSweepingsLbs'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.mpcPackagingAfFlSweepingsLbs}
                    error={
                      touched.mpcPackagingAfFlSweepingsLbs &&
                      !!errors.mpcPackagingAfFlSweepingsLbs
                    }
                    helperText={
                      touched.mpcPackagingAfFlSweepingsLbs &&
                      errors.mpcPackagingAfFlSweepingsLbs
                    }
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Accupoint Swabs Completed (Y/N)
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='mpcPackagingAccupointSwabsCompleted'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.mpcPackagingAccupointSwabsCompleted}
                    error={
                      touched.mpcPackagingAccupointSwabsCompleted &&
                      !!errors.mpcPackagingAccupointSwabsCompleted
                    }
                    helperText={
                      touched.mpcPackagingAccupointSwabsCompleted &&
                      errors.mpcPackagingAccupointSwabsCompleted
                    }
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    % Seal Checks In Spec
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='mpcPackagingSealChecksInSpec'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.mpcPackagingSealChecksInSpec}
                    error={
                      touched.mpcPackagingSealChecksInSpec &&
                      !!errors.mpcPackagingSealChecksInSpec
                    }
                    helperText={
                      touched.mpcPackagingSealChecksInSpec &&
                      errors.mpcPackagingSealChecksInSpec
                    }
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Sifting Pwd Needing Fixed (If Y, area?)
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='mpcPackagingSiftingPwdNeedingFixed'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.mpcPackagingSiftingPwdNeedingFixed}
                    error={
                      touched.mpcPackagingSiftingPwdNeedingFixed &&
                      !!errors.mpcPackagingSiftingPwdNeedingFixed
                    }
                    helperText={
                      touched.mpcPackagingSiftingPwdNeedingFixed &&
                      errors.mpcPackagingSiftingPwdNeedingFixed
                    }
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    % Weight Checks in Spec
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size='small'
                    name='mpcPackagingWeightChecksInSpec'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.mpcPackagingWeightChecksInSpec}
                    error={
                      touched.mpcPackagingWeightChecksInSpec &&
                      !!errors.mpcPackagingWeightChecksInSpec
                    }
                    helperText={
                      touched.mpcPackagingWeightChecksInSpec &&
                      errors.mpcPackagingWeightChecksInSpec
                    }
                  />
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Condition of Deck 2
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <Select
                    fullWidth
                    size='small'
                    name='mpcPackagingConditionDeck2'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.mpcPackagingConditionDeck2}
                    error={
                      touched.mpcPackagingConditionDeck2 &&
                      !!errors.mpcPackagingConditionDeck2
                    }
                    helperText={
                      touched.mpcPackagingConditionDeck2 &&
                      errors.mpcPackagingConditionDeck2
                    }
                  >
                    <MenuItem value=''>Please Select</MenuItem>
                    <MenuItem value='1-Very Poor (Powder on walls, floor, and machinery, needs lots of work!)'>
                      1-Very Poor (Powder on walls, floor, and machinery, needs
                      lots of work!)
                    </MenuItem>
                    <MenuItem value='2-Poor (Some powder on walls, floor, or machinery, needs some work)'>
                      2-Poor (Some powder on walls, floor, or machinery, needs
                      some work)
                    </MenuItem>
                    <MenuItem value='3-Decent (Most of the powder is cleaned up, still could use some attention)'>
                      3-Decent (Most of the powder is cleaned up, still could
                      use some attention)
                    </MenuItem>
                    <MenuItem value='4-Good (Most of the powder is cleaned up with little time could be spotless'>
                      4-Good (Most of the powder is cleaned up with little time
                      could be spotless)
                    </MenuItem>
                    <MenuItem value='5-Excellent (No powder in sight, everything in proper place'>
                      5-Excellent (No powder in sight, everything in proper
                      place)
                    </MenuItem>
                  </Select>
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Condition of Deck 3
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <Select
                    fullWidth
                    size='small'
                    name='mpcPackagingConditionDeck3'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.mpcPackagingConditionDeck3}
                    error={
                      touched.mpcPackagingConditionDeck3 &&
                      !!errors.mpcPackagingConditionDeck3
                    }
                    helperText={
                      touched.mpcPackagingConditionDeck3 &&
                      errors.mpcPackagingConditionDeck3
                    }
                  >
                    <MenuItem value=''>Please Select</MenuItem>
                    <MenuItem value='1-Very Poor (Powder on walls, floor, and machinery, needs lots of work!)'>
                      1-Very Poor (Powder on walls, floor, and machinery, needs
                      lots of work!)
                    </MenuItem>
                    <MenuItem value='2-Poor (Some powder on walls, floor, or machinery, needs some work)'>
                      2-Poor (Some powder on walls, floor, or machinery, needs
                      some work)
                    </MenuItem>
                    <MenuItem value='3-Decent (Most of the powder is cleaned up, still could use some attention)'>
                      3-Decent (Most of the powder is cleaned up, still could
                      use some attention)
                    </MenuItem>
                    <MenuItem value='4-Good (Most of the powder is cleaned up with little time could be spotless'>
                      4-Good (Most of the powder is cleaned up with little time
                      could be spotless)
                    </MenuItem>
                    <MenuItem value='5-Excellent (No powder in sight, everything in proper place'>
                      5-Excellent (No powder in sight, everything in proper
                      place)
                    </MenuItem>
                  </Select>
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ textAlign: 'right', pr: 1 }}>
                    Deep Clean Area
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <Select
                    fullWidth
                    size='small'
                    name='mpcPackagingDeepCleanArea'
                    disabled={recordLock}
                    onChange={(e) => handleChange(e, values, setValues)}
                    value={values.mpcPackagingDeepCleanArea}
                    error={
                      touched.mpcPackagingDeepCleanArea &&
                      !!errors.mpcPackagingDeepCleanArea
                    }
                    helperText={
                      touched.mpcPackagingDeepCleanArea &&
                      errors.mpcPackagingDeepCleanArea
                    }
                  >
                    <MenuItem value=''>Please Select</MenuItem>
                    <MenuItem value='1-Very Poor (Powder on walls, floor, and machinery, needs lots of work!)'>
                      1-Very Poor (Powder on walls, floor, and machinery, needs
                      lots of work!)
                    </MenuItem>
                    <MenuItem value='2-Poor (Some powder on walls, floor, or machinery, needs some work)'>
                      2-Poor (Some powder on walls, floor, or machinery, needs
                      some work)
                    </MenuItem>
                    <MenuItem value='3-Decent (Most of the powder is cleaned up, still could use some attention)'>
                      3-Decent (Most of the powder is cleaned up, still could
                      use some attention)
                    </MenuItem>
                    <MenuItem value='4-Good (Most of the powder is cleaned up with little time could be spotless'>
                      4-Good (Most of the powder is cleaned up with little time
                      could be spotless)
                    </MenuItem>
                    <MenuItem value='5-Excellent (No powder in sight, everything in proper place'>
                      5-Excellent (No powder in sight, everything in proper
                      place)
                    </MenuItem>
                  </Select>
                </Grid>
              </Grid>
              <ActionBar
                id={id}
                editOnly={true}
                values={values}
                setValues={setValues}
                record='supermiddry'
                newToolTip='New Super Mid Dry Passdown'
              />
            </Form>
          </>
        )}
      </Formik>
    </>
  )
}

export default SuperMidDry
